import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import clsx from "clsx";
import { IconButton, Divider, Drawer, Tooltip } from "@mui/material";
import {
  ChevronLeft,
  MenuBook,
  ChevronRight,
  Satellite,
  // TrendingUpOutlined,
  CropLandscape,
  Cloud,
} from "@mui/icons-material";
import {
  EachLayoutCard,
  EachLayoutInnerCard,
  EachLayoutSubtitle,
  EachLayoutDSubtitle,
  EachLayoutTitle,
  LayoutIcons,
  LayoutSideBar,
} from "../../styles/util/UtilStyle";
import { Link } from "react-router-dom";
import { AppContext } from "../../appRouter";
import { connect } from "react-redux";
import { getMyRole } from "../../redux/actions/userManagement";

const Sidebar = (props) => {
  const { user_details, getMyRole, my_roles } = props;
  const [layoutDropDown, setLayoutDropDown] = useState({
    first: false,
    second: false,
    third: false,
    fourth: false,
    fifth: false,
  });

  const { selectedCentroid, selectedFieldId, indexing, weather } =
    useContext(AppContext);
  const fetchMyRoles = async () => {
    if (user_details?.role === undefined) {
      return;
    }
    const res = await getMyRole();
    if (!res.success) {
      // return team_roles?.map((priv) => priv.privileges)[0];
      console.log(res);
    } else {
      // setLoading(false);
    }
  };
  // MY_ROLES
  useEffect(() => {
    fetchMyRoles();
  }, []);

  const privileges = useMemo(() => {
    if (my_roles) {
      return my_roles[0]?.role?.privileges;
    }
  }, [my_roles]);
  const sales_privileges = useMemo(() => {
    if (my_roles) {
      return (
        my_roles[0]?.role?.privileges?.some((el) =>
          el?.includes("products.")
        ) ||
        my_roles[0]?.role?.privileges?.some((el) =>
          el?.includes("products.")
        ) ||
        my_roles[0]?.role?.privileges?.some((el) => el?.includes("inventory."))
      );
    }
  }, [my_roles]);

  const layouts = [
    {
      name: "Farm Management",
      pos: "first",
      icon: <MenuBook />,
      permission: true,
      innerLayouts: [
        {
          id: "1",
          name: "Dashboard",
          route: "/dashboard/",
          permission: true,
        },
        {
          id: "2",
          name: "Farming Activities",
          route: "/dashboard/farmactivity/all-activities",
          permission: true,
        },
        {
          id: "3",
          name: "Farm Summary",
          route: "/dashboard/farmsummary/",
          permission: true,
        },
        {
          id: "4",
          name: "My Farm Task",
          route: "/dashboard/farmactivity/my-tasks",
          permission: true,
        },
      ],
    },

    {
      name: "Sales and Inventory",
      pos: "second",
      icon: <MenuBook />,
      permission: sales_privileges,
      innerLayouts: [
        {
          id: "1",
          name: "Dashboard",
          route: "/sales-inventory/dashboard/",
          permission: true,
        },
        {
          id: "2",
          name: "Products",
          route: "/sales-inventory/products",
          permission: privileges?.some((el) => el?.includes("products.")),
        },
        {
          id: "3",
          name: "Raw Materials",
          route: "/sales-inventory/raw-materials",
          permission: privileges?.some((el) => el?.includes("inventory.")),
        },
        {
          id: "4",
          name: "Inventory",
          route: "/sales-inventory/inventory",
          permission: privileges?.some((el) => el?.includes("inventory.")),
        },
        {
          id: "5",
          name: "Sales",
          route: "/sales-inventory/sales",
          permission: privileges?.some((el) => el?.includes("sales.")),
        },
      ],
    },
    {
      name: "Crop Plan Development",
      pos: "third",
      icon: <CropLandscape />,
      permission: true,
      innerLayouts: [
        {
          id: "7",
          name: "Crop Plan configuration",
          route: "/dashboard/crop-plan/config/farm/" + selectedFieldId,
          permission: true,
        },
        // { id: "9", name: "Crop Monitoring" },
      ],
    },
    {
      name: "Satellite Field Monitoring",
      pos: "fourth",
      icon: <Satellite />,
      permission: true,
      innerLayouts: [
        {
          id: "14",
          name: "Render satellite view of Farm",
          route: "/dashboard/satellite-view/",
          permission: true,
        },
        {
          id: "15",
          name: "Image Comparison and Processing",
          route: "/dashboard/split-view/",
          disabled: !indexing,
          permission: true,
        },
      ],
    },
    {
      name: "Weather Forecast & Update",
      pos: "fifth",
      icon: <Cloud />,
      permission: true,
      innerLayouts: [
        {
          id: "16",
          name: "Weather and chart analysis",
          route: "/dashboard/weather/history/" + selectedCentroid,
          disabled: !weather,
          permission: true,
        },
        {
          id: "17",
          name: "Weather Forecast",
          route: "/dashboard/weather/forecast/" + selectedCentroid,
          disabled: !weather,
          permission: true,
        },
      ],
    },
  ];

  const handleNavClick = (item) => {
    if (props.open) {
      setLayoutDropDown({ [item]: true });
    }
  };

  const handleDrawClose = () => {
    props.handleDrawerClose();
    setLayoutDropDown({
      first: false,
      second: false,
      third: false,
      fourth: false,
      fifth: false,
    });
  };
  return (
    <>
      <Drawer
        variant="permanent"
        // className={clsx(props.classes.drawer, {
        //   [props.classes.drawerOpen]: props.open,
        //   [props.classes.drawerClose]: !props.open,
        // })}
        classes={{
          paper: clsx({
            [props.classes.drawerOpen]: props.open,
            [props.classes.drawerClose]: !props.open,
          }),
        }}
      >
        <div className={props.classes.toolbar}>
          <IconButton onClick={handleDrawClose}>
            {props.theme.direction === "rtl" ? (
              <ChevronRight />
            ) : (
              <ChevronLeft />
            )}
          </IconButton>
        </div>
        <Divider />
        <LayoutSideBar>
          {layouts
            ?.filter((el) => el?.permission)
            .map((eachLayout) => (
              <EachLayoutCard key={eachLayout?.pos}>
                <EachLayoutTitle
                  onClick={() => handleNavClick(eachLayout?.pos)}
                >
                  <LayoutIcons>{eachLayout?.icon} </LayoutIcons>{" "}
                  {eachLayout.name}
                </EachLayoutTitle>
                {layoutDropDown?.[eachLayout?.pos] && (
                  <>
                    <EachLayoutInnerCard>
                      {eachLayout?.innerLayouts
                        ?.filter((el) => el?.permission)
                        ?.map((eachInnerLayout) => (
                          // eachInnerLayout?.disabled?
                          // <Link
                          //   key={eachInnerLayout.id}
                          //   to={eachInnerLayout?.route}
                          //   onClick={ (event) => event.preventDefault()}
                          // >
                          //   <Tooltip title="Upgrade Plan to Access" arrow>
                          //   <EachLayoutDSubtitle>
                          //     {eachInnerLayout?.name}
                          //   </EachLayoutDSubtitle>
                          //   </Tooltip>
                          // </Link>
                          // :
                          <Link
                            key={eachInnerLayout.id}
                            to={eachInnerLayout?.route}
                          >
                            <EachLayoutSubtitle>
                              {eachInnerLayout?.name}
                            </EachLayoutSubtitle>
                          </Link>
                        ))}
                    </EachLayoutInnerCard>
                    <Divider style={{ background: "rgba(255,255,255,0.7)" }} />
                  </>
                )}
              </EachLayoutCard>
            ))}
        </LayoutSideBar>
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user_details: state.authReducer.user_details,
    // team_roles: state.userManagementReducer.team_roles,
    my_roles: state.userManagementReducer.my_roles,
  };
};

export default connect(mapStateToProps, { getMyRole })(Sidebar);
